import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=68fb8a6c&scoped=true&"
import script from "./ReportTable.vue?vue&type=script&lang=js&"
export * from "./ReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fb8a6c",
  null
  
)

export default component.exports